import React, { Component } from "react";
import { TIMEOUT_AGREMENTS } from "../constants/general";
import defaultLogo from "../img/logo.png";
class AboutApp extends Component {
  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.props.handleEnd();
    }, TIMEOUT_AGREMENTS);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const blocks = this.props.text?.split("|||"); // rozdělíme bloky
    return (
      <div className="App aboutapp">
        <div className="mt-50">
          <div className="box-content ">
            <img
              src={
                this?.props?.logo
                  ? `data:image/png;base64,${this.props.logo}`
                  : defaultLogo
              }
              alt="Logo"
            />
            <div>
              {blocks?.map((block, i) => {
                const lines = block?.split("||"); // první řádek = nadpis
                const [title, ...points] = lines;

                return (
                  <div key={i} style={{ marginBottom: "1.5em" }}>
                    <h2 style={{ textAlign: "left" }}>{title}</h2>
                    {points?.map((p, j) => (
                      <p style={{ textAlign: "left" }} key={j}>
                        {p}
                      </p>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="d-flex justify-center mt-2">
            <button
              className="btn-continue"
              onClick={this.props.handleAcceptAboutApp}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutApp;
